import 'bootstrap';
import './css/site.scss';
import '@progress/kendo-theme-default/dist/all.css';

import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { CaseFileModelProvider } from './contexts/CaseFileModelContext';
import { CheckmateRoutes } from './components/layouts/CheckmateRoutes';
import { CollabModalProvider } from './pages/report/collab-report/modals/CollabModalContext';
import { GlobalSidePanels } from './components/side-panel/GlobalSidePanels';
import { LoadingProvider } from './contexts/LoadingContext';
import { PanelProvider } from './components/side-panel/PanelContext';
import { SignalRProvider } from './contexts/SignalRContext';
import { ToastContainer } from 'react-toastify';
import { UnauthorizedError } from './utilities/Errors/UnauthorizedError';
import { ZoneProvider } from './contexts/ZoneContext';
import { useEffect } from 'react';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            notifyOnChangeProps: 'tracked',
            retry: false,
            onError: (error) => {
                if (error instanceof UnauthorizedError) {
                    window.location.reload();
                }
            },
        },
    },
});

const router = createBrowserRouter([{ path: '*', element: <Root /> }]);

export default function App() {
    return <RouterProvider router={router} />;
}

function Root() {
    useEffect(() => {
        preventDuplicateTab();
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <LoadingProvider>
                <SignalRProvider>
                    <AuthProvider>
                        <PanelProvider>
                            <ZoneProvider>
                                <CollabModalProvider>
                                    <CaseFileModelProvider>
                                        <CheckmateRoutes />
                                    </CaseFileModelProvider>
                                    <ToastContainer
                                        containerId="error"
                                        position="top-center"
                                        style={{ top: 90 }}
                                    />
                                    <ToastContainer containerId="success" position="bottom-right" />
                                    <GlobalSidePanels />
                                </CollabModalProvider>
                            </ZoneProvider>
                        </PanelProvider>
                    </AuthProvider>
                </SignalRProvider>
            </LoadingProvider>
        </QueryClientProvider>
    );
}

function preventDuplicateTab() {
    if (sessionStorage.tabCreateTimestamp) {
        if (!window.name) {
            window.name = 'tab';
            sessionStorage.tabCreateTimestamp = Date.now();
            window.location.reload();
        }
    } else {
        sessionStorage.tabCreateTimestamp = Date.now();
    }
}
